export default function() {
  return {
    ready: false,
    init() {
      this.ready = true;
    }
  };
}
